export const reviewConstants = {
    REMOVE_REVIEW_SUCCESS: "REMOVE_REVIEW_SUCCESS",
};